<template>
  <div>

  <div id="wrapper">
    <img src="../assets/my/2025.png" style="height:120px;"/>
  		<div id="content" style="height:690px;">

  			<p style="font-size:large; float:none;">
  				<strong>
  				    Home
  				</strong>
  			</p>
  <p style="line-height:1.6;">
      Welcome to the 16th Integrative Data Analysis in Systems Biology and Data Science (IDASB 2025)
  </p>

  <p style="line-height:1.6;">
     Systems biology as a discipline aims to comprehend intricate biological processes and their correlation to phenotype at the systems level.
  </p>

  <p style="line-height:1.6;">
      Systems biology investigates biological systems by systematically perturbing them (biologically, genetically, or chemically); monitoring the responses of genes, proteins, small molecules, and informational pathways; integrating multi-dimensional data; and ultimately, formulating mathematical models that elucidate the system's structure and its response to individual perturbations.
  </p>

  <p style="line-height:1.6;">
      In the current big data era, integrated "omics" approaches have opened up thrilling opportunities for systems biology researchers.
      This workshop offers a platform for exchange and discussion on integrated data science analysis approaches in systems biology research such as network analysis, panomics, pattern recognition, feature learning, data representation, and visualization.
  </p>


        <p>
          Research topics included in the workshop:
        </p>

         		<ul class="my-c">
                  <li>	Large-scale or cross-species data integration for the reconstruction of networks and pathways</li>
                  <li>	Genomic data analysis using systems biology approaches </li>
  				<li>	Data science approaches and applications </li>
                  <li>	Large language models and applications in biological and biomedical fields</li>
                  <li>	Analysis, methods and tools for the data from single cells, tissue specificity, and time series.</li>
  				<li>	Dynamics of regulatory, signalling, interaction and metabolic networks through modelling and simulation techniques</li>
  				<li>	Prediction of protein/RNA structure and biological networks interactions</li>
                  <li>	Single cell multi-omics data analysis and visualization </li>
                  <li>	Deep learning of complex biological or biomedical data</li>
                  <li>	Data integration and knowledge driven approach in biomarker identification and drug discovery</li>
  				<li>	Semantic webs and ontology-driven biological data integration methods</li>
  				<li>	Data standardization from multi-domains</li>
  				<li>	Development of integrated systems biology visualisation and analysis tools</li>
  				<li>	Complex network analysis in systems biology</li>
                  <li>Integration of heterogeneous and omics data in medicine</li>
  				<li>	Big data analysis in biological systems</li>
  				<li>	Modality, scalable and interpretable informatics approaches for complex data mining</li>
  				<li>	Multiscale modelling and computing in systems biology and systems medicine</li>

  				<li>	Metagenomics in systems biology</li>
  				<li>	Integrative analysis of omics data with images or phenotypic data.</li>
          <li>	Multi-omics integrated database and web service development in systems biology</li>
          <li>	Integrative analysis of spatial multi-omics data</li>
  			</ul>
             <p style="line-height:1.6;">
                 We invite you to submit papers with unpublished, original research describing recent advances on the areas related to this workshop. All papers will undergo peer review by the conference program committee. All papers accepted will be included in the Workshop Proceedings published by the IEEE Computer Society Press and will be available at the workshops.
             </p>
             <p style="line-height:1.6;">
                 Authors of selected papers will be invited to extend their papers for submission to a special issue in <i>International Journal of Computational Biology and Drug Design</i>.
             </p>

              <footer-component></footer-component>
  		</div>
  	</div>

  </div>
</template>
<script>
  // footer
  import FooterComponent from '@/components/Foot/footer.vue'
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
  import PageVisitsTable from './Dashboard/PageVisitsTable';

  export default {
    components: {
      LineChart,
      BarChart,
      BaseProgress,
      StatsCard,
      PageVisitsTable,
      SocialTrafficTable,
      FooterComponent
    },
    data() {
      return {



        bigLineChart: {
          allData: [
            [0, 20, 10, 30, 15, 40, 20, 60, 60],
            [0, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [
              {
                label: 'Performance',
                data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
              }
            ],
            labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          },
          extraOptions: chartConfigs.blueChartOptions
        }
      };
    },
    methods: {
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Performance',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      }
    },
    mounted() {
      this.initBigChart(0);
    }
  };
</script>
<style>
p, li {
  /* 优先用 Times New Roman（常见学术衬线字体），没找到就用系统默认衬线 */
  font-family: "Times New Roman", Times, serif;
  padding: 0px 5px 0px 10px;
  margin: 0px 10px 0px 10px;
  line-height: 2; /* 调整回更接近参考文本的行高 */
  color: black;
  font-weight: normal; /* 参考文本是常规字重，去掉 bold */
  text-align: justify;
  text-justify: inter-ideograph;
  font-size: large;
}

.el-table .cell{
  padding-left: 0px;
  padding-right: 0px;
}
 .my-c {
      margin: 20px;
      padding: 10px;
    }
    p {
      /*或者使用 shorthand 属性*/
      /*padding: 上 右 下 左*/
      /*margin: 上 右 下 左*/
      padding: 0px 5px 0px 10px;
      margin: 0px 10px 0px 10px;
      /* padding:0px;
      margin: 0px; */
      line-height:120%;
      color: black;
      font-weight: bold;
      text-align: justify;
      text-justify: inter-ideograph;
    }
    li {
      color: black;
    }

</style>
